import {createApp} from "vue";
import {createPinia} from "pinia";
const pinia= createPinia();
// Components
// import '../components'

// Sync router with store

// Application imports
import App from '../pages/App.vue'
import router from '../router'
import Netpify from '../netpify';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// Vue.use(VueMeta, {
//     // optional pluginOptions
//     refreshOnceOnNavigation: false
// })

/* eslint-disable no-new */

const app=createApp(App).use(pinia)



app.use(Netpify);
app.use(router);
app.use(VueSweetalert2);
app.config.productionTip = false

app.mount('#vue-app')
